<div class="d-flex bgcomp flex-column mh-100 clinical-feedback">
  <div class="mx-3 pt-3">
    <app-search-orders
      class="w-100"
      (submitSearch)="onSearchSubmit($event)"
      (clearSearch)="onSearchClear()"
    ></app-search-orders>
  </div>
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  <div class="d-flex flex-grow-1 overflow-fix">
    <app-clinical-feedback-table
      class="pt-2"
      [studyItems]="studyItemsDataSource$ | async"
      [searchApplied]="searchApplied"
      [searchOrderOverLimit]="searchOrderOverLimit"
      (refreshFeedbackTable)="refreshFeedbackTable()"
    ></app-clinical-feedback-table>
  </div>
</div>
